import PubSub from 'pubsub-js';
import { useDispatch } from 'react-redux';
import {
  combineUnityObjectDataWithReact,
} from '../../../../helpers/unityHelper';
import {
  selectIsSelectMapModeActive,
  selectPropertiesTabScrollTop,
  setActiveTab,
  setSelectMapMode,
  TAB_NAME,
} from '../../../../redux/slicers/admin/curatorStylesSlicer';
import {
  clearTempObjectData,
  selectSelectedObjectName,
  selectTempUnitySelectedObjectInfo,
} from '../../../../redux/slicers/admin/curatorUnityObjectSlicer';
import { getAppState } from '../../../../redux/store';
import { errorToast } from '../../../../helpers/toastHelper';
import { UnityEvent } from '../../../../helpers/unityPubSub';
import { paginatedTexturesActions } from '../../../../redux/slicers/textures/paginatedTexturesSlicer';
//import { captureException } from '@sentry/react';
import { unitycontext } from '../../../../hooks/useUnityContext';
import { useContext } from 'react';


export const useMapSelection = () => {
  const dispatch = useDispatch();
  const unity = useContext(unitycontext);

  const setTempSelectedTexture = (texture) => {
    dispatch(paginatedTexturesActions.setTempSelectedTexture(texture));
  }

  const restoreScrollAfterCustomMap = () => {
    if (!unity.propertiesScrollableElementId) return;

    // scroll to section
    const element = document.getElementById(unity.propertiesScrollableElementId);
    const top = selectPropertiesTabScrollTop(getAppState())
    element?.scrollTo(0, top);
  }

  const cancelMapSelection = async () => {
    const isSelectMapModeActive = selectIsSelectMapModeActive(getAppState());
    if (!isSelectMapModeActive) return;

    setTempSelectedTexture(null);
    dispatch(setSelectMapMode(null));
    dispatch(setActiveTab(TAB_NAME.PROPERTIES));
    dispatch(paginatedTexturesActions.resetFilters())

    // revert to previous state if user seelcted some custom maps
    const prevData = selectTempUnitySelectedObjectInfo(getAppState());
    if (!prevData) {
      restoreScrollAfterCustomMap();
      return;
    }

    try {
      const rawObject = combineUnityObjectDataWithReact(prevData.raw, prevData.parsed, { applySelectedColor: true });
      const objectName = prevData.raw.objectName;
      await unity.materialModule.SetMaterialPropertiesOnGivenObject(rawObject, objectName);

      const selectedObjectName = selectSelectedObjectName(getAppState());
      if (objectName === selectedObjectName) {
        const object = { ...rawObject, TRIGGERED_FROM_REACT: true };
        PubSub.publish(UnityEvent.ReceiveSelectedObjectInfo, JSON.stringify(object)); // simulate unity trigger to go through all flow of selecting styleable object
      }
    } catch (e) {
      //captureException(e);
      console.error(e);
      errorToast('Something went wrong while cancelling map selection');
    }

    dispatch(clearTempObjectData());

    restoreScrollAfterCustomMap();
  };

  return { cancelMapSelection, setTempSelectedTexture, restoreScrollAfterCustomMap }
}
